import { render, staticRenderFns } from "./tag-icons.vue?vue&type=template&id=050b8eaa&scoped=true"
import script from "./tag-icons.vue?vue&type=script&lang=js"
export * from "./tag-icons.vue?vue&type=script&lang=js"
import style0 from "./tag-icons.vue?vue&type=style&index=0&id=050b8eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b8eaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
